import axios from 'axios'

export interface Permission {
  path: string
  create: boolean
  read: boolean
  update: boolean
  delete: boolean
}

export interface RoleAccess {
  role_id: number
  permissions: Permission[]
}

class RoleAccessService {
  async getRoles() {
    try {
      const response = await axios.get('/role-access/roles')
      return response.data
    } catch (error) {
      console.error('Error fetching roles:', error)
      throw error
    }
  }

  async getPermissions(roleId: number) {
    try {
      const response = await axios.get(`/role-access/${roleId}`)
      return response.data
    } catch (error) {
      console.error('Error fetching permissions:', error)
      throw error
    }
  }

  async updatePermissions(roleId: number, permissions: Permission[]) {
    try {
      const response = await axios.post(`/role-access/${roleId}`, {
        permissions
      })
      return response.data
    } catch (error) {
      console.error('Error updating permissions:', error)
      throw error
    }
  }
}

export default new RoleAccessService()
